export const getHash = () => {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  const href = window.location.href;
  const hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

export const replaceHash = (path) => {
  const hashIndex = window.location.href.indexOf('#');
  window.location.replace(
    `${window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0)}#${path}`,
  );
};
